module.exports = __webpack_public_path__ + "static/media/profile.c9e53fad.svg";